<template>
<div>
  <div class="columns">
    <div class="column is-4">
      <text-input 
        :value="secondaryScraper.scraper_payload"
        @input="updateScraperPayload"
      />
    </div>
  </div>
</div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {

  methods: {
    ...mapMutations('secondaryScraper', [
      'updateScraperPayload'
    ])
  },
  
  computed: {
    ...mapGetters('secondaryScraper', [
      'secondaryScraper'
    ])
  }

}
</script>